var _rect, _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBusinessIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 64,
    height: 64,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M41 35.1086L36.4004 39.7082C36.2783 39.8303 36.1266 39.9187 35.9602 39.9648C35.7938 40.0109 35.6182 40.0131 35.4507 39.9713L28.2061 38.1601C28.0702 38.1261 27.943 38.064 27.8326 37.9777L21 32.6349L25.0718 24.9746L31.4868 23.1044C31.716 23.0376 31.9614 23.055 32.1789 23.1534L36.5 25.1086H33.9142C33.7829 25.1086 33.6529 25.1344 33.5315 25.1847C33.4102 25.235 33.3 25.3086 33.2071 25.4015L28.3153 30.2933C28.214 30.3946 28.1356 30.5165 28.0855 30.6507C28.0354 30.7849 28.0148 30.9284 28.0249 31.0713C28.0351 31.2142 28.0758 31.3532 28.1444 31.479C28.213 31.6048 28.3078 31.7144 28.4224 31.8004L29.1 32.3086C29.7924 32.8279 30.6345 33.1086 31.5 33.1086C32.3655 33.1086 33.2076 32.8279 33.9 32.3086L35.5 31.1086L41 35.1086Z",
    fill: "#23BD33"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M46.0897 31.223L43 32.7678L39 25.1076L42.1212 23.547C42.3557 23.4297 42.6268 23.4093 42.8763 23.49C43.1257 23.5707 43.3335 23.7461 43.4548 23.9785L46.5289 29.8657C46.5904 29.9834 46.6278 30.1122 46.639 30.2445C46.6501 30.3768 46.6348 30.5101 46.5939 30.6364C46.553 30.7628 46.4874 30.8797 46.4008 30.9804C46.3143 31.0811 46.2085 31.1636 46.0897 31.223V31.223Z",
    stroke: "#23BD33",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M20.9999 32.633L17.9102 31.0882C17.7914 31.0288 17.6857 30.9464 17.5991 30.8456C17.5125 30.7449 17.4469 30.628 17.406 30.5016C17.3651 30.3753 17.3498 30.2421 17.361 30.1097C17.3721 29.9774 17.4095 29.8486 17.471 29.7309L20.5451 23.8438C20.6665 23.6114 20.8742 23.4359 21.1237 23.3552C21.3731 23.2745 21.6443 23.295 21.8788 23.4122L24.9999 24.9728L20.9999 32.633Z",
    stroke: "#23BD33",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M43 32.7687L41 35.1085L36.4004 39.7081C36.2783 39.8302 36.1266 39.9186 35.9602 39.9647C35.7938 40.0108 35.6182 40.013 35.4507 39.9712L28.2061 38.16C28.0702 38.126 27.943 38.0639 27.8326 37.9776L21 32.6348",
    stroke: "#23BD33",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M41.0001 35.1074L35.5001 31.1074L33.9001 32.3074C33.2077 32.8267 32.3655 33.1074 31.5001 33.1074C30.6346 33.1074 29.7924 32.8267 29.1001 32.3074L28.4225 31.7992C28.3078 31.7133 28.213 31.6037 28.1445 31.4779C28.0759 31.3521 28.0351 31.213 28.025 31.0701C28.0148 30.9272 28.0355 30.7838 28.0856 30.6496C28.1357 30.5153 28.214 30.3934 28.3154 30.2921L33.2072 25.4003C33.3 25.3075 33.4103 25.2338 33.5316 25.1835C33.6529 25.1333 33.7829 25.1074 33.9143 25.1074H39.0001",
    stroke: "#23BD33",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M25.0713 24.9746L31.4863 23.1044C31.7154 23.0376 31.9609 23.055 32.1784 23.1534L36.4995 25.1086",
    stroke: "#23BD33",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M30 42.6077L26.2326 41.6658C26.0797 41.6276 25.938 41.5538 25.8191 41.4504L23 39",
    stroke: "#23BD33",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBusinessIcon);
export default __webpack_public_path__ + "static/media/Business_icon.566f7805a82230f94b40062a49228725.svg";
export { ForwardRef as ReactComponent };